
<template>
  <div class="Listenlist" v-title data-title="雅思机考_雅思剑桥_雅思模考_雅思真题 - 羊驼雅思官网">
    <div class="layout" style="padding-top: 64px">

      <Head :isPhone="false" :headerNum="1" />
      <Card style="width: 1000px;margin: 20px auto" v-if="list.length !== 0">
        <div class="card-top">
          <h1 slot="title" class="title">
            <img src="/static/img/cambrdge20190124.png" style="width: 40px;height: 40px;margin-right: 3px;">
            剑桥雅思
            <h1 class="top-title">
              雅思机考
            </h1>
          </h1>

        </div>


        <div class="section" style="height: 640px;margin: 10px">
          <GeminiScrollbar class="my-scroll-bar">

            <div class="content" v-for="(item, index) in list.data.domainList" :key="index">
              <h1 class="list-title">剑桥雅思 {{ item.camNum }}</h1>
              <!-- <p class="list-title-p">{{2018-index}}年IELTS最新模拟题，根据剑雅真题书中的题目整理而成</p> -->
              <ul>
                <li v-for="(item1, index1) in item.categoryTestDomains" :key="index1">
                  <div class="li-left">
                    <img src="/static/img/computer190227.png" style="width: 16px;height: 14px;" />
                    <p style="padding-left: 15px">剑雅{{ item.camNum }}-Test{{ item1.testNum }}</p>
                    <img src="/static/img/collect_grey20190124.png" style="width: 22px;height: 22px;margin-left: 20px;" />
                  </div>
                  <div class="li-right" @click="goTest(item.camNum, item1.testNum)">
                    开始考试
                  </div>
                </li>
              </ul>

            </div>

          </GeminiScrollbar>
        </div>


        <div class="bottom-img">
          <img src="/static/img/logo_font20190124.png" />
        </div>
      </Card>
      <!--</Layout>-->
    </div>
  </div>
</template>
<script>
import Head from './../../components/Head'
import ajax from './../../api/ajax'
import { getCookie } from "../../api/cookie";

export default {
  data() {
    return {
      url: "https://winielts.com",
      list: [],
      items: 0,
      select: '按剑雅套题',
      selectList: [
        {
          value: '按剑雅套题',
          label: '按剑雅套题'
        },
        {
          value: '按Section',
          label: '按Section'
        },
        {
          value: '按题目类型',
          label: '按题目类型'
        },
      ],
      itemName: 0,
    }

  },
  components: {
    Head
  },
  methods: {
    goTest(camNum, testNum) {
      if (!getCookie("token")) {
        this.$Message.info('请先登录！');
        return
      }
      this.$router.push({ name: 'exercise', params: { camNum: camNum, testNum: testNum, sectionNum: 0 } });
    },
  },
  async mounted() {
    if (window.__PRERENDER_INJECTED) {
      throw "PrerenderSPAPlugin render";
    }
    this.$Spin.show({
      render: (h) => {
        return h('div', [
          h('Icon', {
            'class': 'demo-spin-icon-load',
            props: {
              type: 'ios-loading',
              size: 18
            }
          }),
          h('div', 'Loading')
        ])
      }
    });
    const list = await ajax(this.url + '/api/ieltsCategory/list', { topicType: 1 })
    this.list = list
    this.itemName = list.data.camNumList[0]
    console.log(this.itemName);
    this.$Spin.hide();
    // this.camNum =
  }
}
</script>
<style>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.gm-scrollbar .thumb {
  background-color: #f2f2f2 !important;
}
</style>
<style scoped lang="stylus">
  .list-title
    color: #ff8c19
    font-size: 16px;
  .list-title-p
    color: #b3b3b3
    font-size: 14px;
    padding-top:4px
  .top-title
    color: #ff8c19;
    font-size:18px
    padding-left: 20px;
  .card-top
    display: flex
    border-bottom: 1px solid #f2f2f2
    padding-bottom: 16px
    align-items: center
    justify-content: space-between
  html
    font-size: 10px
  .bottom-img
    border-top:1px solid #e8eaec
    height 40px
    img
      width: 8.4rem
      margin: 0px auto;
      display: block;
      height: 2rem;
      display: block;
      margin-top:1.2rem
  .content
    position: relative
    ul
      padding: 14px 0;
      li:hover
        background-color: #f7fcff
      li
        display: flex
        justify-content: space-between
        height: 3rem
        align-items: center
        width:98%
        .li-left
          display: flex
          padding-left: 20px
          align-items: center
        .li-right
          color: #ff8c19;
          font-size: 14px;
          cursor pointer
          width: 80px;
          height: 24px;
          text-align: center
          line-height 24px
          font-family Regular
        .li-right:hover
          color: #fff
          background-color: #ff8c19;
          border-radius: 2px;


  .select
    background #ff952b
    p
      color: #fff
  /*width:100%*/
  .list-ul
    display: flex
    /*width: 70%;*/
    justify-content: space-evenly;
    li
      /*padding 0 1.2rem*/
      cursor: pointer
      border-radius: 14px;
      height: 28px
      display: flex
      align-items: center
      margin 0 10px
      width 50px
      text-align: center
      justify-content: center
    li:hover
      background #ff952b
    li:hover p
      color  #fff
      p
        width 100%
        color: #ff8c19;
        font-size: 1.4rem;
  .title
    font-size: 2rem;
    color: #333333;
    display: flex;
    align-items: center;
  .Listenlist
    height: 100%
    width: 100%
    background-color: #f7f7f7!important;
  .layout{
    border-bottom: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    height:100%
  }
  .layout-header-bar{
    background: #fff;
    box-shadow: 0 1px 1px rgba(0,0,0,.1);
  }
  .menu-item span{
    display: inline-block;
    overflow: hidden;
    width: 69px;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    transition: width .2s ease .2s;
  }
  .menu-item i{
    transform: translateX(0px);
    transition: font-size .2s ease, transform .2s ease;
    vertical-align: middle;
    font-size: 16px;
  }
  .collapsed-menu span{
    width: 0px;
    transition: width .2s ease;
  }
  .collapsed-menu i{
    transform: translateX(5px);
    transition: font-size .2s ease .2s, transform .2s ease .2s;
    vertical-align: middle;
    font-size: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/ExerciseList/ExerciseList.vue